// ── AEROSPACE images ──
import tBulkRingImg  from '../assets/T BULK RING Ø 2840MM (ALU).jpg';
import aftShieldImg  from '../assets/AFT SHEILD ASSY  FIX.jpg';
import aeRingImg     from '../assets/AE RING Ø 2250MM.jpg';
import canisterImg   from '../assets/CANISTER Ø 2250MM.jpg';
import pic4Img       from '../assets/Picture4.jpg';
import vsscImg       from '../assets/VSSC-GAGANYAAN.jpg';
import nadirImg      from '../assets/NADIR ASSY FIX 4.4 METER.jpg';
import csatImg       from '../assets/CSAT ASSY FIX 4.2 METER.jpg';
import aeroSectorAssembly    from '../assets/aerospace c setor asseply.jpeg';
import aeroSectorAssemblyFix from '../assets/aerospace c setor asseply fixture.jpeg';
import cSectFix1     from '../assets/c sect assebly fix (1).jpeg';
import cSectFix2     from '../assets/c sect assebly fix (2).jpeg';

// ── DEFENCE images ──
import k4Img         from '../assets/K-4.jpg';
import bottomCylImg  from '../assets/bottom cylinder assemply.jpeg';

// ── WINDMILL images ──
import windRotorMain from '../assets/windmill/rotor size dia 5m height 1 (1).jpeg';
import windRotor1    from '../assets/windmill/rotor size dia 5m height 1 (2).jpeg';
import windRotor2    from '../assets/windmill/rotor size dia 5m height 1 (3).jpeg';
import windRotor3    from '../assets/windmill/rotor size dia 5m height 1 (4).jpeg';
import windStator1   from '../assets/windmill/stateor size 2.7m dia  1.5m height  (1).jpeg';
import windStator2   from '../assets/windmill/stateor size 2.7m dia  1.5m height  (2).jpeg';
import windBottomCyl from '../assets/windmill/bottom cylinder assemply.jpeg';
import windTormel    from '../assets/windmill/tormel gummiert size 1.6m dia 1.2m height.jpeg';
import windmill27    from '../assets/windmill/windmill (27).jpeg';

export const products = [

  // ═══════════════ AEROSPACE ═══════════════
  {
    id: 1,
    name: 'Fore End Ring Ø 2840',
    shortName: 'Fore End Ring',
    category: 'aerospace',
    tag: 'ISRO',
    material: 'Aluminium Alloy (ALU)',
    diameter: 'Ø 2840 mm',
    image: tBulkRingImg,
    gallery: [tBulkRingImg],
    description: 'CNC-machined aluminium fore end ring for ISRO launch vehicle payload fairing. Manufactured to tight aerospace tolerances on our large-capacity BERTHIEZ CNC VTL.',
    specs: {
      Diameter: 'Ø 2840 mm',
      Material: 'Aluminium Alloy',
      Process: 'CNC VTL Turning',
      Tolerance: '±0.05 mm',
      Surface: 'As Machined / Anodised',
      Client: 'ISRO',
    },
  },
  {
    id: 2,
    name: 'AFT Shield Assembly Fix',
    shortName: 'AFT Shield',
    category: 'aerospace',
    tag: 'ISRO',
    material: 'Structural Steel',
    diameter: '—',
    image: aftShieldImg,
    gallery: [aftShieldImg],
    description: 'Robust aft shield assembly fixture used during integration of ISRO launch vehicle stages. Fabricated and machined for zero-compromise structural integrity.',
    specs: {
      Type: 'Assembly Fixture',
      Material: 'Structural Steel',
      Process: 'Fabrication + CNC Machining',
      Finish: 'Zinc Primer',
      Client: 'ISRO',
    },
  },
  {
    id: 3,
    name: 'AE Ring Ø 2250',
    shortName: 'AE Ring',
    category: 'aerospace',
    tag: 'ISRO',
    material: 'Alloy Steel',
    diameter: 'Ø 2250 mm',
    image: aeRingImg,
    gallery: [aeRingImg],
    description: 'Large-diameter aft end ring for rocket stage integration, machined to micron-level accuracy using the BERTHIEZ 8.2m CNC VTL.',
    specs: {
      Diameter: 'Ø 2250 mm',
      Material: 'Alloy Steel',
      Process: 'CNC VTL Turning',
      Tolerance: '±0.02 mm',
      Client: 'ISRO',
    },
  },
  {
    id: 4,
    name: 'T Bulk Ring Ø 2840',
    shortName: 'T Bulk Ring',
    category: 'aerospace',
    tag: 'ISRO',
    material: 'Aluminium Alloy',
    diameter: 'Ø 2840 mm',
    image: tBulkRingImg,
    gallery: [tBulkRingImg],
    description: 'Thrust bulkhead ring machined from aircraft-grade aluminium. Load-bearing interface between propellant stage and payload bay on ISRO launch vehicles.',
    specs: {
      Diameter: 'Ø 2840 mm',
      Material: 'Aluminium Alloy',
      Process: 'CNC VTL Turning',
      Client: 'ISRO PSLV',
    },
  },
  {
    id: 5,
    name: 'Canister Ø 2250',
    shortName: 'Canister',
    category: 'aerospace',
    tag: 'ISRO / VSSC',
    material: 'High-Strength Steel',
    diameter: 'Ø 2250 mm',
    image: canisterImg,
    gallery: [canisterImg],
    description: 'Cylindrical canister assembly for housing avionics and telemetry systems aboard ISRO launch vehicles. Manufactured at VSSC specifications.',
    specs: {
      Diameter: 'Ø 2250 mm',
      Material: 'High Strength Steel',
      Process: 'CNC Turning + Milling',
      Client: 'ISRO / VSSC',
    },
  },
  {
    id: 6,
    name: 'Canister Ø 2500 HT-2250',
    shortName: 'Canister XL',
    category: 'aerospace',
    tag: 'ISRO / VSSC',
    material: 'High-Strength Steel',
    diameter: 'Ø 2500 mm',
    image: pic4Img,
    gallery: [pic4Img],
    description: 'Larger-diameter canister with extended height for additional payload accommodation on ISRO GSLV and PSLV-XL vehicles.',
    specs: {
      Diameter: 'Ø 2500 mm',
      Height: '2250 mm',
      Material: 'High Strength Steel',
      Client: 'ISRO GSLV / PSLV-XL',
    },
  },
  {
    id: 7,
    name: 'CEOS Adaptor Assembly',
    shortName: 'CEOS Adaptor',
    category: 'aerospace',
    tag: 'Gaganyaan · VSSC',
    material: 'Carbon Steel',
    diameter: 'Fixed Config',
    image: vsscImg,
    gallery: [vsscImg],
    description: "Crew module adaptor for India's first crewed spaceflight mission — Gaganyaan. Manufactured, assembled, and painted by MILLTECH CNC under VSSC supervision.",
    specs: {
      Type: 'Crew Module Adaptor',
      Material: 'Carbon Steel',
      Process: 'CNC Machining + Assembly + Painting',
      Programme: 'Gaganyaan',
      Client: 'VSSC / ISRO',
    },
  },
  {
    id: 8,
    name: 'NADIR Assembly Fix',
    shortName: 'NADIR Assy',
    category: 'aerospace',
    tag: 'ISRO',
    material: 'Mild Steel',
    diameter: '4.4 Metre Span',
    image: nadirImg,
    gallery: [nadirImg],
    description: 'Large nadir-pointing instrument mounting fixture with 4.4m span. Machined from structural steel for satellite integration at ISRO.',
    specs: {
      Span: '4.4 Metres',
      Material: 'Mild Steel',
      Process: 'Fabrication + CNC Machining',
      Client: 'ISRO',
    },
  },
  {
    id: 9,
    name: 'CSAT Assembly Fix',
    shortName: 'CSAT Assy',
    category: 'aerospace',
    tag: 'ISRO',
    material: 'Mild Steel',
    diameter: '4.2 Metre Span',
    image: csatImg,
    gallery: [csatImg, aeroSectorAssembly, aeroSectorAssemblyFix],
    description: 'Communication satellite assembly fixture spanning 4.2m. Supports final integration operations for ISRO communication satellites.',
    specs: {
      Span: '4.2 Metres',
      Material: 'Mild Steel',
      Process: 'Fabrication + CNC Machining',
      Client: 'ISRO ComSat',
    },
  },
  {
    id: 19,
    name: 'C-Sector Assembly Fixture',
    shortName: 'C-Sector Assy',
    category: 'aerospace',
    tag: 'ISRO',
    material: 'Structural Steel',
    diameter: '—',
    image: cSectFix1,
    gallery: [cSectFix1, cSectFix2, aeroSectorAssembly, aeroSectorAssemblyFix],
    description: 'C-sector assembly fixture for ISRO launch vehicle stage integration. Large-scale structural fixture machined and fabricated to ISRO drawing specifications.',
    specs: {
      Type: 'Assembly Fixture',
      Material: 'Structural Steel',
      Process: 'Fabrication + CNC Machining',
      Client: 'ISRO',
    },
  },

  // ═══════════════ DEFENCE ═══════════════
  {
    id: 10,
    name: 'Canister Ø 2250 — Defence',
    shortName: 'Defence Canister',
    category: 'defence',
    tag: 'BrahMos / DRDO',
    material: 'High-Grade Alloy Steel',
    diameter: 'Ø 2250 mm',
    image: canisterImg,
    gallery: [canisterImg],
    description: 'High-strength cylindrical canister manufactured under stringent defence security protocols for missile system integration. Machined to exact BrahMos specifications.',
    specs: {
      Diameter: 'Ø 2250 mm',
      Programme: 'Defence — Restricted',
      Material: 'High-Grade Alloy Steel',
      Process: 'CNC Precision Machining',
      Client: 'BrahMos / DRDO',
    },
  },
  
  {
    id: 11,
    name: 'K-4 Body Cylinder',
    shortName: 'K-4',
    category: 'defence',
    tag: 'BrahMos / DRDO',
    material: 'High-Grade Alloy Steel',
    diameter: '—',
    image: k4Img,
    gallery: [k4Img],
    description: 'Mission-critical multi-stage stacked body cylinder component for ballistic missile systems, machined under stringent defence security protocols with zero-tolerance quality.',
    specs: {
      Programme: 'Defence — Restricted',
      Material: 'High-Grade Alloy Steel',
      Process: 'CNC Machining',
      Client: 'BrahMos / DRDO',
    },
  },
  {
    id: 21,
    name: 'Bottom Cylinder Assembly — Defence',
    shortName: 'Bottom Cylinder',
    category: 'defence',
    tag: 'BrahMos / DRDO',
    material: 'Structural Steel',
    diameter: '—',
    image: bottomCylImg,
    gallery: [bottomCylImg],
    description: 'Heavy-duty defence-grade bottom cylinder assembly machined with precision alignment and structural integrity for missile launch system applications.',
    specs: {
      Type: 'Cylinder Assembly',
      Programme: 'Defence — Restricted',
      Material: 'Structural Steel',
      Process: 'CNC Machining + Fabrication',
      Client: 'BrahMos / DRDO',
    },
  },

  // ═══════════════ WINDMILL ═══════════════
  {
    id: 12,
    name: 'Rotor — Dia 5m',
    shortName: 'Rotor',
    category: 'windmill',
    tag: 'Renewable Energy',
    material: 'Alloy Steel',
    diameter: 'Ø 5000 mm',
    image: windRotorMain,
    gallery: [windRotorMain, windRotor1, windRotor2, windRotor3],
    description: 'Precision-machined rotor (Dia 5m, Height 1m) for wind turbines — manufactured on our 12.5m KOLB Gantry and BERTHIEZ 8.2m VTL with full dimensional traceability.',
    specs: {
      Type: 'Rotor',
      Diameter: 'Ø 5000 mm',
      Height: '1000 mm',
      Material: 'Alloy Steel',
      Process: 'Gantry Machining + VTL Turning',
      Machine: 'KOLB 12.5m Gantry / BERTHIEZ 8.2m VTL',
      Client: 'Windmill OEMs',
    },
  },
  {
    id: 15,
    name: 'Stator — Dia 2.7m',
    shortName: 'Stator',
    category: 'windmill',
    tag: 'Renewable Energy',
    material: 'Alloy Steel',
    diameter: 'Ø 2700 mm',
    image: windStator1,
    gallery: [windStator1, windStator2],
    description: 'Precision-manufactured stator (Dia 2.7m, Height 1.5m) engineered to meet stringent dimensional and quality requirements for wind turbine generator applications.',
    specs: {
      Type: 'Stator',
      Diameter: 'Ø 2700 mm',
      Height: '1500 mm',
      Material: 'Alloy Steel',
      Process: 'CNC Machining + Heavy Fabrication',
      Client: 'Windmill OEMs',
    },
  },
  {
    id: 16,
    name: 'Bottom Cylinder Assembly',
    shortName: 'Bottom Cylinder',
    category: 'windmill',
    tag: 'Renewable Energy',
    material: 'Structural Steel',
    diameter: '—',
    image: windBottomCyl,
    gallery: [windBottomCyl],
    description: 'Heavy-duty bottom cylinder assembly fabricated and machined for accurate alignment, structural strength, and long-term operational reliability in wind turbine systems.',
    specs: {
      Type: 'Cylinder Assembly',
      Material: 'Structural Steel',
      Process: 'Fabrication + CNC Machining',
      Client: 'Windmill OEMs',
    },
  },
  {
    id: 17,
    name: 'Tormel Gummiert — Dia 1.6m',
    shortName: 'Tormel Gummiert',
    category: 'windmill',
    tag: 'Renewable Energy',
    material: 'Alloy Steel',
    diameter: 'Ø 1600 mm',
    image: windTormel,
    gallery: [windTormel],
    description: 'Tormel gummiert component (Dia 1.6m, Height 1.2m) — precision-machined wind turbine component with strict adherence to customer specifications and industry standards.',
    specs: {
      Type: 'Tormel Gummiert',
      Diameter: 'Ø 1600 mm',
      Height: '1200 mm',
      Material: 'Alloy Steel',
      Process: 'CNC Machining',
      Client: 'Windmill OEMs',
    },
  },
  {
    id: 18,
    name: 'Windmill Structural Component',
    shortName: 'Windmill Part',
    category: 'windmill',
    tag: 'Renewable Energy',
    material: 'Alloy Steel',
    diameter: '—',
    image: windmill27,
    gallery: [windmill27],
    description: 'Precision CNC-machined windmill structural component manufactured using advanced gantry and VTL machining for high accuracy and consistent quality.',
    specs: {
      Type: 'Structural Component',
      Material: 'Alloy Steel',
      Process: 'CNC Machining + Fabrication',
      Client: 'Windmill OEMs',
    },
  },

  // ═══════════════ CEMENT ═══════════════
  // No product images available — cement products removed from listing

];

export const getProductById        = (id)  => products.find(p => p.id === parseInt(id));
export const getProductsByCategory = (cat) => cat === 'all' ? products : products.filter(p => p.category === cat);